import React from 'react';
import { ManRadioButtonGroup, ManRadioButton,ManText } from '@craft-design-system/core-components-react';

const AverageDisplayFirstOnly = ({ averages, unit }) => {
  console.log('averages', averages, 'unit', unit);
  if (averages === undefined || averages === null) {
    return <div>No data available</div>;
  }

  return (
    <div
      style={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '16px',
        maxWidth: '300px',
        padding: '16px' // Optional: for spacing
      }}
    >
      {/* Averages and Unit side by side */}
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        
        {/* Ø and average value */}
        <span
          style={{
            fontSize: '28px',
            fontWeight: 600,
            marginRight: '6px',
            color: '#111827',
            display: 'flex',
            alignItems: 'baseline'
          }}
        >
          Ø&nbsp;
          <ManText className="card-title-text" variant="component-xl" as="span" size="xl">
            {typeof averages === 'number' ? averages.toFixed(2) : averages}
          </ManText>
        </span>
  
        {/* Unit */}
        <span
          style={{
            fontSize: '16px',
            color: '#6B7280'
          }}
        >
          {unit}
        </span>
      </div>
    </div>
  );
  
};


export default AverageDisplayFirstOnly;
